<template>
  <div class="choiceType">
    <!--创建新单-->
    <el-dialog :title="title" :visible.sync="dialogAdd" :close-on-click-modal="false" width="350px">
      <el-radio-group v-model="radio" class="tradeType">
        <el-radio v-for="(item, index) in options" :key="index" :label="item.value">{{
          item.label
        }}</el-radio>
      </el-radio-group>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import BASE_API from '@/api/dataBase.js';
  import PURASE_API from '@/api/purchaseSalesCenter/purchaseSales.js';
  import AGENCY_API from '@/api/agencyContract/index';

  export default {
    name: 'originalsReceivedDialog',
    data() {
      return {
        dialogAdd: false,
        loading: false,
        options: [],
        radio: '',
        title: '',
        dialogType: '',
        rowInfo: null,
      };
    },
    props: ['vFlag'],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      // 正本归档状态
      originalsReceivedRmOpt() {
        return this.$baseRequest.getDictListMapByType('originalsReceivedRm');
      },
      //正本收集状态
      originalsReceivedBusinessOpt() {
        return this.$baseRequest.getDictListMapByType('originalsReceivedBusiness');
      },
    },
    methods: {
      openDialog(flag, type, rowInfo) {
        this.dialogAdd = flag;
        this.dialogType = type;
        this.radio = '';
        this.rowInfo = rowInfo;
        this.title = type == 'originalsReceivedBusiness' ? '正本收集' : '正本归档';
        this.getOptions(type);
      },
      getOptions(type) {
        if (type == 'originalsReceivedRm') {
          this.options = this.originalsReceivedRmOpt;
        } else if (type == 'originalsReceivedBusiness') {
          this.options = this.originalsReceivedBusinessOpt;
        }
      },
      addSure() {
        if (this.radio == '') {
          this.$message({
            showClose: true,
            message: this.$t('salePurchase.noOrderError'),
            type: 'error',
          });
          return;
        }
        let url = '';
        let params = { contractNos: this.rowInfo.contractNo };
        if (this.dialogType == 'originalsReceivedBusiness') {
          params['originalsReceivedBusiness'] = this.radio;
        } else {
          params['originalsReceivedRm'] = this.radio;
        }
        if (this.vFlag == 'purchase' || this.vFlag == 'sale') {
          url =
            this.dialogType == 'originalsReceivedBusiness'
              ? PURASE_API.UPDATE_ORDER_ORB
              : PURASE_API.UPDATE_ORDER_ORR;
        } else {
          url =
            this.dialogType == 'originalsReceivedBusiness'
              ? AGENCY_API.UPDATE_TRADE_ORB
              : AGENCY_API.UPDATE_TRADE_ORR;
        }

        this.$axios.post(url, params).then((res) => {
          if (res.data.code == 0) {
            this.$emit('confirm');
            this.dialogAdd = false;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .tradeType {
    display: block;
    // width: 100%;
    margin-left: 30%;
    .el-radio {
      height: 30px;
      margin-right: 0px;
      display: block;
    }
  }
</style>
